import {createSlice} from '@reduxjs/toolkit';

export const APP_STORE_NAME = 'hiJet';

const initialState = {
    counter: 0,
};

const userSlice = createSlice({
    name: APP_STORE_NAME,
    initialState,
    reducers: {
        setCounter(state, {payload}) {
            state.counter = state.counter + payload
        },
        resetCounter(state) {
            state.counter = 0
        },
    },
});

export const {actions, reducer} = userSlice;
